@if (cardItems().length) {
  <section class="ebooks-container">
    <sirius-spacer size="large"></sirius-spacer>
    <div class="ebooks-header">
      <h2 class="ebooks-title sir-text-style-title-l-default">{{ translations()!.resultPage.ebookTitle }}</h2>
      <p class="ebooks-description sir-text-style-paragraph-l-default">
        {{
        translations()!.resultPage.ebookDescription
        | interpolate: { application: application() }
        }}
      </p>
    </div>
    <sirius-slider>
      @for (item of cardItems(); track item) {
        <div class="ebook-card">
          <div class="ebook-container">
            <sirius-image-item [image]="item.thumbnail"></sirius-image-item>
          </div>
          <div class="button-wrapper">
            <h2 class="ebook-title sir-text-style-paragraph-l-bold">{{ item.title }}</h2>
            <a
              class="download-button"
              data-cy="download-button"
              siriusButton
              [attr.target]="'_blank'"
              download="true"
              [download]="item.title"
              [siriusLink]="item.ebook"
              [buttonText]="translations()!.button.downloadEbook"
              buttonType="primary">
            </a>
          </div>
        </div>
      }
    </sirius-slider>
    <sirius-spacer size="large"></sirius-spacer>
  </section>
}
